<template>
  <div id="modal">
    <div class="modal-backdrop"></div>
    <div class="modal" :class="show ? 'is-active' : ''">
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">
          <slot name="header"></slot>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer border-0 pt-0">
            <slot name="footer">
              <button type="reset" class="btn btn-primary" @click="close">Ok</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ESCAPE } from "../utils/constants";

export default {
  name: "modal",
  props: ["show"],
  mounted() {
    document.addEventListener("keydown", e => {
      if (this.show && e.keyCode === ESCAPE) {
        this.close();
      }
    });
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.is-active {
  display: block;
}
</style>
